import * as announcementApi from '../../api/announcementApi'

const state={
    announcementInput:{
    },
    announcementOutput:{
        NoticeCount:0,
        Notice:'',
        MessageCount:0,
        Message:''
    },
    noticeListInput:{

    },
    noticeListOutput:{
        Rows:[],
        HasNext:true,
        PageNo:0,
        PageSize:15
    },
    noticeDetailInput:{
       
    },
    noticeDetailOutput:{
       
    },
   messageListInput:{
        
    },
    messageListOutput:{
        Rows:[],
        HasNext:true,
        PageNo:0,
        PageSize:15
    },
    messageDetailInput:{
       
    },
    messageDetailOutput:{
       
    },
    hasError:false
    
}

const getters={

}

const actions ={
    async getNoticeCenter({commit},announcementInput){
        const response =await announcementApi.getNoticeCenter(announcementInput);
        commit('setNoticeCenter',response)
        return response
    },
    async getNoticeList({commit},noticeListInput){
        const response =await announcementApi.getNoticeList(noticeListInput);
        commit('setNoticeList',response)
        return response
    },
    async getNoticeDetail({commit},noticeDetailInput){
        const response =await announcementApi.getNoticeDetail(noticeDetailInput);
        commit('setNoticeDetail',response)
        return response
    },
    async getMessageList({commit},messageListInput){
        const response =await announcementApi.getMessageList(messageListInput);
        commit('setMessageList',response)
        return response
    },
    async getMessageDetail({commit},messageDetailInput){
        const response =await announcementApi.getMessageDetail(messageDetailInput);
        commit('setMessageDetail',response)
        return response
    }
}

const mutations ={
    setNoticeCenter(state,data){
        if(data.Status){
            state.announcementOutput=data.Data;
        }
    },
    setNoticeList(state,data){
        if(data.Status){
            state.noticeListOutput.Rows=state.noticeListOutput.Rows.concat(data.Rows)
            state.noticeListOutput.HasNext=data.HasNext;
            state.noticeListOutput.PageNo=data.PageNo;
            state.noticeListOutput.PageSize=data.PageSize;
        }else
        {
            state.noticeListOutput.HasNext=false;
        }
    },
    setNoticeDetail(state,data){
        if(data.Status){
            state.noticeDetailOutput=data.Data;
        }
    }, 
    setMessageList(state,data){
        state.hasError=!data.Status
        if(data.Status){
            state.messageListOutput.Rows=state.messageListOutput.Rows.concat(data.Rows)
            state.messageListOutput.HasNext=data.HasNext;
            state.messageListOutput.PageNo=data.PageNo;
            state.messageListOutput.PageSize=data.PageSize;
        }else
        {
            state.messageListOutput.HasNext=false;
        }
    },
    setMessageDetail(state,data){
        if(data.Status){
            state.messageDetailOutput=data.Data;
        }
    },
    clearNotelist(state,data){
        state.hasError=false
        state.noticeListOutput={
            Rows:[],
            HasNext:true,
            PageNo:0,
            PageSize:15
        }
    }
}

export default{
     namespaced:true,
     getters,
     state,
     actions,
     mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/announcement.js